import { useNavigationContext } from '../../context/navigationContext';

export interface DocumentNavigationData {
  navigationHistory: {
    sessionId: string;
    startTime: string;
    endTime?: string;
    totalSteps: number;
    uniquePages: string[];
    totalDuration: number;
    steps: Array<{
      id: string;
      timestamp: string;
      path: string;
      searchParams: string;
      hash: string;
      duration?: number;
      timeOnPage?: number;
      referrer?: string;
      userAgent?: string;
      screenResolution?: string;
    }>;
    stats: {
      totalSteps: number;
      uniquePages: number;
      totalDuration: number;
      avgTimePerPage: number;
      mostVisitedPage: { path: string; visits: number } | null;
      sessionDuration: number;
    } | null;
  };
  exportTime: string;
  userEmail?: string;
}

export const useDocumentNavigationData = () => {
  const { getNavigationDataForDocument } = useNavigationContext();

  const getNavigationData = (): DocumentNavigationData | null => {
    return getNavigationDataForDocument();
  };

  const getNavigationDataAsString = (): string => {
    const data = getNavigationData();
    return data ? JSON.stringify(data, null, 2) : '';
  };

  const getNavigationDataAsBase64 = (): string => {
    const data = getNavigationData();
    if (!data) return '';
    
    try {
      const jsonString = JSON.stringify(data);
      return btoa(unescape(encodeURIComponent(jsonString)));
    } catch (error) {
      console.error('Errore nella codifica Base64 dei dati di navigazione:', error);
      return '';
    }
  };

  const getNavigationDataAsCompressed = (): string => {
    const data = getNavigationData();
    if (!data) return '';
    
    try {
      const jsonString = JSON.stringify(data);
      // Compressione semplice: rimuovi spazi e caratteri non necessari
      return jsonString.replace(/\s+/g, ' ').trim();
    } catch (error) {
      console.error('Errore nella compressione dei dati di navigazione:', error);
      return '';
    }
  };

  return {
    getNavigationData,
    getNavigationDataAsString,
    getNavigationDataAsBase64,
    getNavigationDataAsCompressed
  };
}; 